module.exports = __webpack_public_path__ + "static/media/52402687_2452973571444486_2479255230072487936_o.f27db8e7.jpg";